import type { BreederReviewItemData, BreederReviewListData } from '../types';

export interface ReviewItemProps
  extends BreederReviewItemData,
    Pick<
      BreederReviewListData,
      | 'onAnswerClick'
      | 'loading'
      | 'canAnswerReviews'
      | 'onEditClick'
      | 'onAnswerClick'
      | 'onCancelClick'
      | 'updateLoading'
      | 'activeReviewId'
      | 'mode'
    > {}
